@use "variables" as *;

.checkedIcon {
  fill: $button-primary-color !important;
}
